module.exports = __webpack_public_path__ + "static/img/ndvi_11.5a1ddb7d.jpg";